"use client";

import React, { useState, useEffect } from 'react';
import HeroVideoSection from '../../components/sections/HeroVideoSection.jsx';
import JewelryShowcaseSection from '../../components/sections/JewelryShowcaseSection.jsx';
import EliteJewelryExperience from '../../components/sections/LuxuryJewelryShowcase.jsx';
import DesignLedJewellery from "../../components/sections/DesignLedJewellery.jsx";
import AccessoriesSection from "@/components/ui/AccessoriesSection";
import InfinitMenus from "@/components/sections/Test";
import Footer from '@/components/layouts/Footer';
import InstagramGallery from '@/components/sections/InstagramGallery';
import VideoGallery from '@/components/sections/VideoGallery.jsx';
import DiscountBanner from '@/components/sections/DiscountBanner.jsx';
import DualPromoBanner from "@/components/sections/DualPromoBannerEnhanced.jsx";
import DiscountTierBanner from "@/components/sections/DiscountTierBanner.jsx";
import SpinnyWheel from '@/components/sections/SpinnyWheel.tsx';
import NewArrivals from '@/components/sections/NewArrivals.jsx';
import CookieConsent from '@/components/sections/CookieConsent.jsx';
const ParallaxHero = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <>
      <HeroVideoSection />

      {!isMobile && <AccessoriesSection />}

      <DualPromoBanner />
      <DiscountBanner />

      {/* Mobile: EliteJewelryExperience then AccessoriesSection */}
      {isMobile && <EliteJewelryExperience />}

      {!isMobile && <NewArrivals />}
      <JewelryShowcaseSection />

      <VideoGallery />

      {/* Desktop only: original position */}
      {!isMobile && <EliteJewelryExperience />}

      <DesignLedJewellery />

      <InstagramGallery />

      <SpinnyWheel />
      <CookieConsent />
      <Footer />
    </>
  );
};

export default ParallaxHero;